import React, {FC} from "react";
import {Route} from "react-router-dom";
import {Routes} from "react-router";
import {CoolingOffListPage} from "backoffice/ui/Pages/CoolingOff/List";


export const CoolingOffPage: FC = () => {
  return (
      <Routes>
        <Route index element={<CoolingOffListPage/>}/>
      </Routes>
  );
}
